'use strict';
const angular = require('angular');
const ngAnimate = require('angular-animate');
/*const ngCookies = require('angular-cookies');
const ngResource = require('angular-resource');
const ngSanitize = require('angular-sanitize');
import 'angular-socket-io';*/

const uiRouter = require('angular-ui-router');
const uiBootstrap = require('angular-ui-bootstrap');
const ngNotification = require('angular-ui-notification');
const ngMask = require('angular-ui-mask');
const ngTranslate = require('angular-translate');
const ngColorPicker = require('angularjs-color-picker').name;
const ngUiselect = require('ui-select');
const dynamicNumber = require('angular-dynamic-number');
// const ngMessages = require('angular-messages');
// import ngValidationMatch from 'angular-validation-match';
/*require('ace-builds');
require('angular-ui-ace');*/

import { routeConfig } from './app.config';

import toolbar from '../components/toolbar/toolbar.component';
import propertybox from '../components/propertybox/propertybox.component';
import blockly from '../components/blockly/blockly.component';
import toolbox from '../components/toolbox/toolbox.component';
import reviewcomponent from '../components/reviewComponent/review.component';
import manageview from '../components/manage-view/manage-view.component';
import hierarchy from '../components/hierarchy/hierarchy.component';
import commonpropertybox from '../components/commonpropertybox/commonpropertybox.component';
import undoredo from '../components/undo-redo/undo-redo.component';
import login from '../components/login/login.component';
import multiCellSelect from '../components/multiCellSelect/multiCellSelect.directive';
import datetimepicker from '../components/datetimePicker/datetimepicker.directive';
import main from './main/main.component';
import help from './help/help.component';
import constants from './app.constants';
import language from './services/language.service';
import counter from './services/counter.service';
import util from '../components/util/util.module';
import signature from '../components/signature/signature.component';
import stepper from '../components/stepper/stepper.component';
import apiconnection from '../components/api-connection/api-connection.component';

import searchFilter from '../components/customFilters/searchFilter';
// Application Components
import DashboardComponent from './dashboard/dashboard.component';
import CreateComponent from './create/create.component';

// Global Services
import localStorage from './localStorage/localStorage.service';
require('textangular/dist/textAngular-sanitize.min');

angular.module('nodeApp', [
/*  ngCookies,
  ngResource,
  ngSanitize,*/
  ngAnimate,
  ngTranslate,
  ngColorPicker,
  require('textangular'),
  ngUiselect,
  multiCellSelect,
/*  'btford.socket-io',
  'ui.ace',
*/
  uiRouter,
  uiBootstrap,
  ngNotification,
  ngMask,
  dynamicNumber,
  localStorage,

/*  _Auth,
  account,
  admin,
  navbar,
  footer,*/
  toolbar,

  propertybox,
  commonpropertybox,
  toolbox,
  reviewcomponent,
  manageview,
  blockly,

  main,
  help,
  constants,
  language,
  counter,
 /* socket,*/
  util,
  DashboardComponent,
  CreateComponent,
  hierarchy,
  commonpropertybox,
  undoredo,
  login,
  signature,
  'angularSpectrumColorpicker',
  'imageupload',
  datetimepicker,
  'ui.bootstrap.datetimepicker',
  searchFilter,
  stepper,
  apiconnection
])
  .config(routeConfig)
  .constant('config', (<any>window).GLOBALS)
  .constant('PROJECTNAME', (<any>window).PROJECTNAME)
  .filter('ratingrange', function () {
    return function (input, total) {
      total = parseInt(total);
      for (var i = 0; i < total; i++)
        input.push(i);
      return input;
    };
  })
  .config(function ($provide) {
    $provide.decorator('taTranslations', ['taRegisterTool', '$delegate', function (taRegisterTool, taTranslations) { // $delegate is the taTranslations we are decorating
      taTranslations.insertImage.tooltip = 'Insert Image URL'
      return taTranslations;
    }]);
  })
  
angular
  .element(document)
  .ready(() => {
    angular.bootstrap(document, ['nodeApp'], {
      strictDi: true
    });
  });
document.oncontextmenu = function() {
    return false;
};



// WEBPACK FOOTER //
// ./client/app/app.ts